(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["key-ingredients"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".key-ingredients-swiper", {
    slidesPerView: 1.5,
    spaceBetween: 20,
    pagination: {
      el: ".key-ingredients-section .swiper-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".key-ingredients-section .swiper-button-next",
      prevEl: ".key-ingredients-section .swiper-button-prev",
    },

    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 28,
        pagination: false,
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
